
import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const VaporInputPercentage = props => {
  const {
    className,
    style,
    value,
    disabled,
    onChange,
    onBlur,
    placeholder } = props;

  const [state, setState] = React.useState(value);
  const [delay, setDelay] = React.useState(null);

  const middleChange = (e) => {
    try {
      let newValue = e.target.value;
      newValue = newValue.replace(",", ".").replace("%", "");
      setState(newValue);
      if (newValue === "")
        newValue = 0;
      newValue = parseFloat(parseFloat(newValue).toFixed(2));
      if (newValue > 100)
        newValue = 100;
      if (newValue < 0)
        newValue = 0;
      onChange(newValue);
    } catch (error) {
      console.log("error", error);
    }
  };

  const pressButton = (e) => {   
    let newValue = value + e;
    if (newValue > 100)
      newValue = 100;
    if (newValue < 0)
      newValue = 0;
    setState(newValue);
    onChange(newValue);
    createTimer(newValue);
  };

  const middleBlur = () => {
    try {
      setState(value);
      onBlur(value);
    } catch (error) {
      console.log("error", error);
    }
  };

  const createTimer = (newValue) => {
    if (delay)
      clearTimeout(delay);
    setDelay(setTimeout(() => {
      onBlur(newValue);
    }, 1000));
  };

  const disableStyle = disabled ? { cursor: "not-allowed" } : {};
  return (
    <div className={`ant-input-number vapor-percentage ${className}`} style={{ ...style, ...disableStyle }}>
      <div className="ant-input-number-handler-wrap">
        <span role="button" aria-label="Increase Value" aria-disabled="false" className="ant-input-number-handler ant-input-number-handler-up" 
          style={value >= 100 || disabled ? { cursor: "not-allowed" } : {}}
          onClick={() => {
            if (value < 100 && !disabled)
              pressButton(1);
          }}>
          <span role="img" aria-label="up" className="anticon anticon-up ant-input-number-handler-up-inner" >
            <svg viewBox="64 64 896 896" focusable="false" data-icon="up" width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"></path>
            </svg>
          </span>
        </span>
        <span role="button" aria-label="Decrease Value" aria-disabled="false" className="ant-input-number-handler ant-input-number-handler-down">
          <span role="img" aria-label="down" className="anticon anticon-down ant-input-number-handler-down-inner"
            style={value <= 0 || disabled ? { cursor: "not-allowed" } : {}}
            onClick={() => {
              if (value > 0 && !disabled)
                pressButton(-1);
            }}>
            <svg viewBox="64 64 896 896" focusable="false" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
            </svg>
          </span>
        </span>
      </div>
      <div className="ant-input-number-input-wrap" >
        <input className="ant-input-number-input" value={`${state === null ? "" : String(state).replace(".",",")}%`} onChange={middleChange} onBlur={middleBlur} placeholder={placeholder} disabled={disabled} style={{...disableStyle}} />

      </div>
    </div>
  );
};

VaporInputPercentage.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string
};

VaporInputPercentage.defaultProps = {
  className: "",
  style: {},
  value: 0,
  disabled: false,
  onChange: undefined,
  onBlur: undefined,
  placeholder: ""
};

export default VaporInputPercentage;
